import { sendRequest } from "../../hooks/requests/useRequest";


export async function getListAgreements(_id_seller) {
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `Seller/ListAgreements/${_id_seller}`);

    if (response.code === 200)
        return {
            code: response.code,
            data: response.data
        }
    else if (response.code === 401)
        return {
            code: response.code,
            msg: response?.data?.msg
        };
    else
        return {
            code: response.code,
            msg: response?.data?.msg
        };
}


export async function getListSellerAll() {
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `Seller/ListSellerAll`);

    if (response.code === 200)
        return {
            code: response.code,
            data: response.data
        }
    else if (response.code === 401)
        return {
            code: response.code,
            msg: response?.data?.msg
        };
    else
        return {
            code: response.code,
            msg: response?.data?.msg
        };
}